import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import axiosInstance from "../utils/axiosConfig";
import "./Home.css";

const startAtozasLogin = () => {
  // Explicit home-page sign-in must clear the logout guard so IdP / product-card
  // SSO (and "Continue with ATOZAS") can mint a fresh Mail session.
  try {
    localStorage.removeItem("atozas_logged_out");
    sessionStorage.removeItem("atozas_logged_out");
  } catch (_e) {
    /* storage unavailable */
  }
  window.location.href = `/auth/atozas?returnTo=${encodeURIComponent("/inbox")}`;
};

const Home = ({ currentUser }) => {
  const [atozasEnabled, setAtozasEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get("/auth/atozas/config")
      .then(({ data }) => {
        if (!cancelled) setAtozasEnabled(Boolean(data && data.enabled));
      })
      .catch(() => {
        if (!cancelled) setAtozasEnabled(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (currentUser) {
    return <Navigate to="/inbox" replace />;
  }

  return (
    <div className="home-page">
      <header className="home-topbar">
        <img
          className="home-logo"
          src="/atozasmail-logo.png"
          alt="ATOZASMail"
        />
        <div className="home-topbar-actions">
          {atozasEnabled ? (
            <button
              type="button"
              className="home-btn home-btn-ghost"
              onClick={startAtozasLogin}
            >
              Sign in
            </button>
          ) : (
            <Link to="/login" className="home-btn home-btn-ghost">
              Sign in
            </Link>
          )}
          <Link to="/register" className="home-btn home-btn-primary">
            Create account
          </Link>
        </div>
      </header>

      <main className="home-main">
        <section className="home-hero">
          <p className="home-eyebrow">Work smarter with ATOZASMAIL </p>
          <h1>
            Modern email
            <span> for daily work</span>
          </h1>
          <p className="home-lead">
            Send, organize, and collaborate with a secure inbox designed for
            @atozasmail.in accounts. Fast, modern, and ready for your daily
            work.
          </p>

          <div className="home-cta-row">
            <Link
              to="/register"
              className="home-btn home-btn-primary home-btn-large"
            >
              Create account
            </Link>
            {atozasEnabled ? (
              <button
                type="button"
                className="home-btn home-btn-outline home-btn-large"
                onClick={startAtozasLogin}
              >
                Continue with ATOZAS
              </button>
            ) : (
              <Link
                to="/login"
                className="home-btn home-btn-outline home-btn-large"
              >
                Sign in
              </Link>
            )}
          </div>

          {atozasEnabled && (
            <p className="home-email-login">
              Prefer email and password?{" "}
              <Link to="/login">Sign in here</Link>
            </p>
          )}

          <ul className="home-features">
            <li>Secure inbox with IMAP sync</li>
            <li>Compose, schedule, and shared group mail</li>
            <li>Modern dashboard on every device</li>
          </ul>
        </section>

        <section className="home-visual" aria-hidden="true">
          <div className="home-mockup">
            <div className="home-mockup-toolbar">
              <span className="home-dot red" />
              <span className="home-dot yellow" />
              <span className="home-dot green" />
              <span className="home-mockup-search">Search mail</span>
            </div>
            <div className="home-mockup-body">
              <aside className="home-mockup-sidebar">
                <div className="home-mockup-compose">Compose</div>
                <div className="home-mockup-nav active">Inbox</div>
                <div className="home-mockup-nav">Sent</div>
                <div className="home-mockup-nav">Drafts</div>
                <div className="home-mockup-nav">Starred</div>
              </aside>
              <div className="home-mockup-inbox">
                <div className="home-mail-row unread">
                  <span className="home-mail-avatar">A</span>
                  <div>
                    <strong>Welcome to ATOZASMail</strong>
                    <p>Your new professional inbox is ready.</p>
                  </div>
                </div>
                <div className="home-mail-row">
                  <span className="home-mail-avatar">T</span>
                  <div>
                    <strong>Team update</strong>
                    <p>Shared Mail Groups.</p>
                  </div>
                </div>
                <div className="home-mail-row">
                  <span className="home-mail-avatar">S</span>
                  <div>
                    <strong>Schedule send</strong>
                    <p>Plan messages for the right time.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="home-footer">
        <span>© {new Date().getFullYear()} ATOZASMail</span>
        <span>Secure · Fast · Simple</span>
      </footer>
    </div>
  );
};

export default Home;
